"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridV4FuturesRiskLess = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
var GridV4FuturesRiskLess;
(function (GridV4FuturesRiskLess) {
    /**
     * 通过copy_type获取活动配置
     * @param copy_type t
     * @returns TActivityConfigResponse
     */
    GridV4FuturesRiskLess.getActivityConfigByCopyType = (copy_type) => {
        return trade_utils_lib_1.Network.get({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/compensation_activity/${copy_type}/`,
        });
    };
    GridV4FuturesRiskLess.useConfig = ({ copy_type, $st, channel }) => {
        const [config, setConfig] = (0, react_1.useState)();
        const [loading, setLoading] = (0, react_1.useState)(true);
        const [errorMsg, setErrorMsg] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            if (!copy_type) {
                setLoading(false);
                return;
            }
            setLoading(true);
            GridV4FuturesRiskLess.getActivityConfigByCopyType(copy_type).subscribe({
                next(value) {
                    const { activity_tag, symbols } = value, p = __rest(value, ["activity_tag", "symbols"]);
                    const [base, quote] = symbols.split("/");
                    const lang = {};
                    activity_tag.forEach((i) => {
                        lang[i.lang] = i.content;
                    });
                    setConfig(Object.assign(Object.assign({}, p), { base,
                        quote,
                        lang, loss_stop_type: TradeAPILib_1.GridStopType.profit_ratio, copy_from: channel }));
                    setLoading(false);
                },
                error(err) {
                    setErrorMsg(err);
                    setLoading(false);
                },
                complete() {
                    setLoading(false);
                },
            });
        }, [$st, copy_type, channel]);
        return { config, loading, errorMsg };
    };
    /**
     * 通过copyType 检查订单是否是 敢赔单
     * @param copyType
     * @returns
     */
    GridV4FuturesRiskLess.isRiskLessOrderCheck = (copyType) => {
        if (!copyType) {
            return false;
        }
        return copyType.startsWith("activity_compensation_");
    };
    GridV4FuturesRiskLess.useRiskLessOrderCheck = (copyType) => {
        return (0, react_1.useMemo)(() => GridV4FuturesRiskLess.isRiskLessOrderCheck(copyType), [copyType]);
    };
    /**
     * 检查敢赔单是否在时间范围内
     * @param param0
     * @returns
     */
    GridV4FuturesRiskLess.checkOrderInactive = ({ start, end }) => {
        const n = Date.now();
        const obj = { startInactive: false, endInactive: false };
        if (start && n < start) {
            obj.startInactive = true;
        }
        if (end && n > end) {
            obj.endInactive = true;
        }
        return obj;
    };
})(GridV4FuturesRiskLess || (exports.GridV4FuturesRiskLess = GridV4FuturesRiskLess = {}));
